import { createContext } from "react";
import waferssServices from "../hooks/waferssServices";
import { useQuery } from "react-query";


// Create initial empty context
const AppContext = createContext(null);

const AppContextProvider = ({ children }) => {
    const { getMenuAll, getLinkImmagini, getAnnoRelazione } = waferssServices();

    const { data: menu } = useQuery(["menu"], getMenuAll, {
        refetchOnWindowFocus: false
    });
    const { data: imaginiForCarousel } = useQuery(["imaginiForCarousel"], getLinkImmagini, {
        refetchOnWindowFocus: false
    });

   
    const { data: annoRelazione } = useQuery(["annoRelazione"], () => getAnnoRelazione({ "anteprima": false }), {
        refetchOnWindowFocus: false,
        retry:false
    });


    const getMenuVisible = () => {
        return menu?.data?.map(item => {
            return {
                ...item,
                voci: item?.voci?.map(voci => {
                    if (voci?.visibile) {
                        return {
                            ...voci,
                            sottoVoci: voci?.sottoVoci?.filter(sottoVoce => sottoVoce?.visibile === true)
                        }
                    } return null;
                }).filter(a => a)
            }
        })
    }

    return (
        <AppContext.Provider value={
            {
                menu: getMenuVisible(),
                imaginiForCarousel: imaginiForCarousel?.data,
                appYear: annoRelazione?.data || new Date().getFullYear()
            }}>
            {children}
        </AppContext.Provider>
    );
};

export default AppContextProvider;
export { AppContext };
